module.exports = __webpack_public_path__ + "static/img/14000538.020ef163.png";